<template>
<Navbar v-if="this.lang == 'id'"></Navbar>
<NavbarEn v-else-if="this.lang == 'en'"></NavbarEn>

	<div class="produk" id="produk">
		<!-- <div class="header-produk">
			<div class="container">
				
				<div class="dropdown">
					<button class="btn btn__white dropdown-toggle" type="button" id="dropdownMenuLink" data-bs-toggle="dropdown" aria-expanded="false">
						
						<span v-if="this.lang == 'en'">Select Product Categories</span>
						<span v-else-if="this.lang == 'id'">Pilih Kategori Produk</span>
					</button>
					<ul class="dropdown-menu" aria-labelledby="dropdownMenuLink">
						<li @click="toggle(item.id)" v-for="item in categories" :key="item.id" id="listCat" :class="{active: active == item.id}">
							<span v-if="this.lang == 'en'">{{ item.nama_kategori_en }}</span>
							<span v-else-if="this.lang == 'id'">{{ item.nama_kategori }}</span>
						</li>
					</ul>
				</div>
			</div>
		</div> -->
		<div class="header-produk">

		</div>
		<!-- <div class="container">
			<div v-if="categoryProducts">
				<div v-for="item in categories" :key="item.id">
					<h1 class="text-center my-5 text-uppercase" v-if="this.lang == 'en'">{{ item.nama_kategori_en }}</h1>
					<h1 class="text-center my-5 text-uppercase" v-else-if="this.lang == 'id'">{{ item.nama_kategori }}</h1>
					<div class="box-group">
						<div class="box-out">
							<router-link :to="'/produk-detail/'+product.id" class="box" v-for="product in categoryProducts.slice().reverse()" :key="product.id">
								<div class="box-inner" v-if="product.id_kategori == item.id">
									<img :src="imageUrl+product.image" class="bg-image" alt="">
									<div class="text">
										<h6 class="title" v-if="this.lang == 'en'">{{ product.nama_produk_en }}</h6>
										<h6 class="title" v-else-if="this.lang == 'id'">{{ product.nama_produk }}</h6>
									</div>
								</div>
							</router-link>
						</div>
					</div>
				</div>
			</div>
		</div> -->
		<div class="container">
			<div class="row">
				<div class="col-lg-4" v-for="product in products" :key="product.id">
					<router-link :to="'/produk-detail/'+product.id" class="box">
						<div class="box-inner">
							<img :src="imageUrl+product.image" class="bg-image" alt="">
							<div class="text">
								<h6 class="title" v-if="this.lang == 'en'">{{ product.nama_produk_en }}</h6>
								<h6 class="title" v-else-if="this.lang == 'id'">{{ product.nama_produk }}</h6>
							</div>
						</div>
					</router-link>
				</div>
			</div>
		</div>

		<div>
			
			<!-- <div>
				<div class="produk-list" v-for="product in categoryProducts.slice().reverse()" :key="product.id">
					<img :src="imageUrl+product.background" class="produk-image" alt="">
					<div class="container">
						<div class="row">
							<div class="col-lg-5 col-md-12">
								<div class="text">
									<div v-if="this.lang == 'en'">
										<h6 class="dark-grey title">Our Products</h6>
										<h1 class="orange">{{ product.nama_produk_en }}</h1>
										<h6 class="purple detail"><router-link :to="'/produk-detail/'+product.id"><hr> Product Detail</router-link></h6>
									</div>
									<div v-else-if="this.lang == 'id'">
										<h6 class="dark-grey title">Produk Kami</h6>
										<h1 class="orange">{{ product.nama_produk }}</h1>
										<h6 class="purple detail"><router-link :to="'/produk-detail/'+product.id"><hr> Detail Produk</router-link></h6>
									</div>
								</div>
							</div>
							<div class="col-lg-7 col-md-12">
								<figure class="p-image">
									<img :src="imageUrl+product.image" alt="">
								</figure>
							</div>
						</div>
					</div>
				</div>
			</div> -->
			<!-- <div>
				<div class="noProduct" v-if="categoryProducts.length === 0">
					<div v-show="noProduct">
						<div class="container">
							<figure class="no__data">
								<img src="../assets/NoData.svg" alt="">
							</figure>
							<h1 class="no__produk text-center" v-if="this.lang == 'en'">No Product Data Available</h1>
							<h1 class="no__produk text-center" v-else-if="this.lang == 'id'">Belum Ada Data Produk Yang Tersedia</h1>
						</div>
					</div>
				</div>
				<div v-if="isProduct">
					<div class="produk-list" v-for="product in products.slice().reverse()" :key="product.id">
						
						<img :src="noImage" class="produk-image" v-if="product.background == null">
						<img :src="imageUrl+product.background" class="produk-image" v-else>
						<div class="container">
							<div class="row">
								<div class="col-lg-5 col-md-12">
									<div class="text">
										<div v-if="this.lang == 'en'">
											<h6 class="dark-grey title">Our Products</h6>
											<h1 class="orange">{{ product.nama_produk_en }}</h1>
											<h6 class="purple detail"><router-link :to="'/produk-detail/'+product.id"><hr> Product Detail</router-link></h6>
										</div>
										<div v-else-if="this.lang == 'id'">
											<h6 class="dark-grey title">Produk Kami</h6>
											<h1 class="orange">{{ product.nama_produk }}</h1>
											<h6 class="purple detail"><router-link :to="'/produk-detail/'+product.id"><hr> Detail Produk</router-link></h6>
										</div>
									</div>
								</div>
								<div class="col-lg-7 col-md-12">
									<figure class="p-image" v-if="product.image === null">
										<img :src="noImage" alt="">
									</figure>
									<figure class="p-image" v-else>
										<img :src="imageUrl+product.image" alt="">
									</figure>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div> -->
		</div>
		
		<!-- <div v-for="categori in categories" :key="categori.id">
			<div v-if="categori.id">
				<div class="header-produk">
					<div class="container">
						<h1 class="purple text-center" v-if="this.lang == 'en'">{{categori.nama_kategori_en}}</h1>
						<h1 class="purple text-center" v-else-if="this.lang == 'id'">{{categori.nama_kategori}}</h1>
						<hr>
					</div>
				</div>
				
			</div>
		</div>
		<div v-for="product in products" :key="product.id">
			<div class="produk-list" v-if="product.id">
				<img :src="'https://admingama.bithouse.id/'+product.image" class="produk-image" alt="">
				<div class="container">
					<div class="row">
						<div class="col-lg-5 col-md-12">
							<div class="text">
								<h6 class="dark-grey title">Produk Kami</h6>
								<h1 class="orange" v-if="this.lang == 'en'">{{ product.nama_produk_en }}</h1>
								<h1 class="orange" v-else-if="this.lang == 'id'">{{ product.nama_produk }}</h1>
								<h6 class="purple detail"><router-link :to="'/produk-detail/'+product.id"><hr> Detail Produk</router-link></h6>
							</div>
						</div>
						<div class="col-lg-7 col-md-12">
							<img :src="'https://admingama.bithouse.id/'+product.image" alt="" class="p-image">
						</div>
					</div>
				</div>
			</div>
		</div> -->
		<div class="langApp">
			<div class="btn-group dropstart">
				<button type="button" class="btn dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
					<svg xmlns="http://www.w3.org/2000/svg" width="26.442" height="30.849" viewBox="0 0 26.442 30.849">
						<path id="Icon_metro-language" data-name="Icon metro-language" d="M16.028,20.761q-.017.052-.215-.009t-.542-.2l-.344-.155a10.314,10.314,0,0,1-1.5-.844q-.121-.086-.706-.542t-.654-.491a29.327,29.327,0,0,1-2.307,3.116,12.8,12.8,0,0,1-1.808,1.894,1.364,1.364,0,0,1-.336.069.663.663,0,0,1-.318,0q.1-.069,1.412-1.584.362-.413,1.472-1.98a24.068,24.068,0,0,0,1.351-2.031q.293-.516.878-1.7a13.418,13.418,0,0,0,.62-1.334,14.146,14.146,0,0,0-1.894.568q-.138.034-.473.129t-.594.164a2.949,2.949,0,0,0-.293.086.293.293,0,0,0-.034.181.382.382,0,0,1-.017.164q-.086.172-.534.258a1.388,1.388,0,0,1-.809,0,.726.726,0,0,1-.482-.362.876.876,0,0,1-.086-.4,3.327,3.327,0,0,1,.422-.086,5.14,5.14,0,0,0,.508-.1q1-.275,1.808-.551,1.721-.6,1.756-.6a3.819,3.819,0,0,0,.74-.336,7.787,7.787,0,0,1,.757-.37q.155-.052.37-.138t.25-.095a.231.231,0,0,1,.1.009,1.959,1.959,0,0,1-.017.568,3.665,3.665,0,0,1-.215.465q-.215.43-.456.921t-.293.577a25.819,25.819,0,0,1-1.326,2.255l1.1.482q.207.1,1.282.551l1.162.482q.069.017.181.439a1.3,1.3,0,0,1,.077.525ZM12.5,12.395a.7.7,0,0,1-.069.482,1.56,1.56,0,0,1-.861.654,2.764,2.764,0,0,1-1.033.207,1.425,1.425,0,0,1-.844-.448,1.3,1.3,0,0,1-.31-.706l.017-.052a.737.737,0,0,0,.336.086,1.5,1.5,0,0,0,.456,0q.172-.034,1-.275a4.915,4.915,0,0,1,.947-.241.34.34,0,0,1,.362.293Zm12.016,2.221L25.6,18.523,23.207,17.8ZM5.441,28.387l11.947-3.994V6.628L5.441,10.639V28.387ZM26.8,22.93l1.756.534-3.116-11.31-1.721-.534L20,20.847l1.756.534.775-1.894,3.632,1.119ZM18.146,6.369,28.01,9.537V3ZM23.5,29.144l2.72.224-.93,2.754L24.6,30.986a12.761,12.761,0,0,1-4.751,1.859,8.25,8.25,0,0,1-1.567.207H16.837a11.635,11.635,0,0,1-3.434-.671,11.431,11.431,0,0,1-3.159-1.463.359.359,0,0,1-.138-.275.333.333,0,0,1,.086-.232.288.288,0,0,1,.224-.095.969.969,0,0,1,.31.129l.525.284q.284.155.353.189a15.252,15.252,0,0,0,2.746,1.059,10.031,10.031,0,0,0,2.711.422,14.69,14.69,0,0,0,2.875-.25,14.188,14.188,0,0,0,2.7-.869q.258-.121.525-.267t.585-.327q.318-.181.491-.284ZM31.211,10.57V29.144L17.887,24.91q-.241.1-6.455,2.195T5.1,29.2a.311.311,0,0,1-.31-.224.132.132,0,0,0-.017-.052V10.363a.768.768,0,0,1,.069-.172A.774.774,0,0,1,5.183,10q1.825-.6,2.565-.861V2.531l9.606,3.408q.034,0,2.763-.947t5.44-1.868q2.711-.921,2.78-.921.344,0,.344.362v7.2Z" transform="translate(-4.77 -2.203)" fill="#0054a5"/>
					</svg>
				</button>
				<ul class="dropdown-menu">
					<a @click="selectLanguage('id')" v-bind:class="'lang-link' + [activeLanguage === 'id' ? ' link__active' : '']">IDN</a>
					<a @click="selectLanguage('en')" v-bind:class="'lang-link' + [activeLanguage === 'en' ? ' link__active' : '']">ENG</a>

				</ul>
			</div>
		</div>

	</div>
	<Footer />
</template>

<script>
	// @ is an alias to /src
	import Footer from '@/components/Footer.vue'
	import Navbar from '@/components/Navbar.vue'
	import NavbarEn from '@/components/NavbarEn.vue'
	import axios from 'axios'
    // import { onMounted,ref } from 'vue'
	// import { useRoute } from 'vue-router'
	
	export default {
		name: 'About',
		components: {
			Footer,
			Navbar,
			NavbarEn
		},
		
		// setup() {
        //     let products = ref([]);
        //     let categories = ref([]);
		// 	const route = useRoute();

        //     onMounted(() => {
        //         // axios.get('https://admingama.bithouse.id/api/getJenisProduk/')
        //         axios.get(`https://admingama.bithouse.id/api/getJenisProduk/${route.params.id}`)
        //         .then((result) => {
        //             products.value = result.data
        //         }).catch((err) => {
        //             console.log(err.response)
        //         })
        //     }),
        //     onMounted(() => {
        //         axios.get(`https://admingama.bithouse.id/api/getKategoriProduk/${route.params.id}`)
        //         .then((result) => {
        //             categories.value = result.data
        //         }).catch((err) => {
        //             console.log(err.response)
        //         })
        //     })

        //     return{
        //         products, categories
        //     }
        // },
		data() {
			return {
				activeLanguage: this.lang,
				active: null,
				noProduct: false,
				isProduct: true,
				allProducts: true,
				categories: [],
				products: [],
			}
		},
		computed: {
			categoryProducts() {
				// let that = this
				return this.products.filter(p => p.id_kategori == p.kategori.id);
				// return this.products.filter(p => p.id_kategori == that.active);
			}
		},
		mounted(){
			axios
			.get("getKategoriProduk")
			.then((response) => this.setCategories(response.data))
			.catch((error) => console.log(error));
			axios
			.get("getJenisProduk")
			.then((response) => this.setProducts(response.data))
			.catch((error) => console.log(error));
		},
		methods: {
			load(load){
				this.load = load;
				location.reload()
			},
			selectLanguage(lang) {
				this.activeLanguage = lang;
				this.lang = lang;
				
				localStorage.setItem("lang", this.lang);
			},
			setCategories(data) {
				this.categories = data;
			},
			setProducts(data) {
				this.products = data;
			},
			toggle(i) {
				this.active = i
				this.allProducts = false
				this.noProduct = true
				this.isProduct = false
				console.log(i)
			}
		}
	}
</script>

<style>
	.active {
        color: var(--secondary-);
    }
	.KatList{
		position: fixed;
		top: 130px;
		left: 0;
	}
    ul li {
        padding: 0 15px;
        list-style: none;
		width: 100%;
		font-weight: 400;
		/* border: 1px solid rgba(62,64,149,0.3) ; */
		/* border-radius: 5px; */
    }
	ul li:hover{
		cursor: pointer;
	}
	.btn .btn__white:focus{
		box-shadow: none;
	}
	.header-produk{
		/* background: url(../assets/wave-2.svg);
		background-size: cover;
		background-position-y: bottom; */
		padding-top: 100px;
		padding-bottom: 50px;
	}
	.header-produk hr{
		background: var(--secondary-);
		height: 4px;
		width: 100px;
		opacity: 1;
		display: block;
		margin: 0 auto;
	}
	.box-group{
		display: block;
		width: 100%;
		margin: 0 auto;
	}
	.box-out{
		display: flex;
		flex-wrap: wrap;
		flex-direction: row;
	}
	.box .box-inner{
		width: 100%;
		height: 200px;
		background: linear-gradient(180deg, rgba(54,114,165,0) 50%, rgba(0,84,165,0.7) 100%);
		position: relative;
		transition: 0.3s;
		margin: 0 10px 20px;
	}
	.box .box-inner:hover{
		cursor: pointer;
		background: linear-gradient(180deg, rgba(54,114,165,0) 40%, rgba(0,84,165,0.9) 100%);
	}
	.box .box-inner .bg-image{
		width: 100%;
		height: 100%;
		object-fit: cover;
		position: absolute;
		top: 0;
		left: 0;
		z-index: -1;
	}
	.box .box-inner .text{
		padding: 20px;
		text-align: center;
	}
	.box .box-inner .text .title{
		position: absolute;
		bottom: 10px;
		width: 95%;
		left: 50%;
		transform: translateX(-50%);
		z-index: 2;
		color: white;
		font-weight: 600;
		text-align: center;
	}


	.produk-list{
		position: relative;
		background: linear-gradient(90deg, rgba(255,255,255,1) 0%, rgba(255,255,255,0.8) 100%);
		width: 100%;
		/* height: 400px; */
		padding: 80px 0;
	}
	.produk-list .produk-image{
		width: 100%;
		height: 100%;
		object-fit: cover;
		position: absolute;
		top: 0;
		left: 0;
		z-index: -1;
	}
	.produk-list .text{
		text-align: right;
		padding-left: 200px;
		position: relative;
		top: 50%;
		transform: translateY(-50%);
	}
	.produk-list .text h6.title{
		text-align: left;
		
	}
	.produk-list .text h6.detail{
		text-align: right;
		padding-top: 20px;
		position: relative;
	}
	.produk-list .text h6.detail a{
		color: var(--primary-);
		font-weight: 600;
		text-transform: uppercase;
		text-decoration: none;
		transition: 0.5s ease-in-out;
	}
	.produk-list .text h6.detail a:hover > hr{
		width: 50px;
	}
	.produk-list .text h6.detail a hr{
		width: 35px;
		height: 2px;
		background: var(--secondary-);
		opacity: 1;
		float: right;
		position: absolute;
		right: 140px;
		top: 12px;
		transition: 0.5s ease-in-out;
	}
	.produk-list .p-image{
		display: block;
		margin: 0 auto;
		width: 90%;
		height: 300px;
		box-shadow: 10px 10px 1px rgba(251,116,62,1);
	}
	.produk-list .p-image img{
		width: 100%;
		height: 100%;
		object-fit: cover;
		background-position-y: center;
	}

	.noProduct{
		width: 100%;
	}
	.noProduct .no__data{
		margin: 50px auto;
		width: 40%;
		height: auto;
	}
	.noProduct .no__produk{
		padding: 0 20px;
		color: var(--secondary-);
		text-transform: capitalize;
		margin-bottom: 30px;
	}


	@media (max-width: 768px)
	{
		.produk-list .text{
			text-align: center;
			padding-left: 10px;
			padding-right: 10px;
			position: relative;
			top: 50%;
			transform: translateY(-50%);
		}
		.produk-list .p-image{
			margin-top: 30px;
		}

		.noProduct .no__data{
			margin: 50px auto;
			width: 80%;
			height: auto;
		}
	}

	@media (max-width: 575.98px){
		.box-out{
			display: block;
			flex-wrap: unset;
			flex-direction: unset;
			width: 100%;
			margin: 0 auto;
		}
		.box .box-inner{
			width: 90%;
			display: block;
			margin: 0 auto 20px;
		}
	}
</style>
